import React from 'react';

import AlertsNotificationContainer from './AlertsNotificationContainer';

export default class MobilAppNavbar extends React.Component {
    constructor(props) {
        super(props);
        this.skipNavigation = this.skipNavigation.bind(this);
    }

    skipNavigation(e) {
        e.preventDefault();
        const pageContent = document.getElementById('page-content');
        const pageFocus = document.querySelector('#page-content h1');
        const yPos = pageContent.getBoundingClientRect().top;

        window.scrollTo(0, yPos);

        if (pageFocus) {
            pageFocus.focus();
        }
    }

    render() {
        return (
            <div>
                <a
                    href="#page-content"
                    className="skip-navigation"
                    onClick={this.skipNavigation}>
                    Skip to main content
                </a>
                <AlertsNotificationContainer autoFetchForLocationChange />
            </div>
        );
    }
}

